var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.actOnEnabled || _vm.shareEnabled
    ? _c(
        "div",
        { staticClass: "viq-actions" },
        [
          _vm.actOnEnabled
            ? _c(
                "button",
                {
                  staticClass: "viq-actions__btn",
                  on: { click: _vm.handleActOnThis },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M5 7l2 2 4-4",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "1",
                          y: "1",
                          width: "12",
                          height: "12",
                          rx: "2",
                          stroke: "currentColor",
                          "stroke-width": "1",
                        },
                      }),
                    ]
                  ),
                  _vm._v("\n    Act on this\n  "),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.shareEnabled
            ? _c(
                "button",
                {
                  staticClass: "viq-actions__btn",
                  on: { click: _vm.handleSaveShare },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M4 8.5a2 2 0 100-4 2 2 0 000 4zM10 3.5a2 2 0 100-4 2 2 0 000 4zM10 13.5a2 2 0 100-4 2 2 0 000 4z",
                          stroke: "currentColor",
                          "stroke-width": "1",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M5.7 7.4l2.6 1.7M5.7 5.6l2.6-1.7",
                          stroke: "currentColor",
                          "stroke-width": "1",
                        },
                      }),
                    ]
                  ),
                  _vm._v("\n    Save & share\n  "),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("transition", { attrs: { name: "viq-fade" } }, [
            _vm.modalOpen
              ? _c(
                  "div",
                  {
                    staticClass: "viq-actions-modal",
                    on: {
                      click: function ($event) {
                        if ($event.target !== $event.currentTarget) return null
                        return _vm.closeModal.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "viq-actions-modal__panel" }, [
                      _c("div", { staticClass: "viq-actions-modal__header" }, [
                        _c(
                          "div",
                          { staticClass: "viq-actions-modal__header-left" },
                          [
                            _c(
                              "div",
                              { staticClass: "viq-actions-modal__icon" },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "16",
                                      height: "16",
                                      viewBox: "0 0 16 16",
                                      fill: "none",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M6 8l2 2 4-4",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("rect", {
                                      attrs: {
                                        x: "1",
                                        y: "1",
                                        width: "14",
                                        height: "14",
                                        rx: "2",
                                        stroke: "currentColor",
                                        "stroke-width": "1",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "h3",
                                { staticClass: "viq-actions-modal__title" },
                                [_vm._v("Send to Workspace")]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "viq-actions-modal__subtitle" },
                                [_vm._v("Create action items on your board")]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "viq-actions-modal__close",
                            on: { click: _vm.closeModal },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "14",
                                  height: "14",
                                  viewBox: "0 0 14 14",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M3 3l8 8M11 3l-8 8",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "viq-actions-modal__body" },
                        [
                          _vm.extracting
                            ? _c(
                                "div",
                                { staticClass: "viq-actions-modal__loading" },
                                [
                                  _c("div", {
                                    staticClass: "viq-actions-modal__spinner",
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v("Extracting action items..."),
                                  ]),
                                ]
                              )
                            : _vm.modalError
                            ? _c(
                                "div",
                                { staticClass: "viq-actions-modal__error" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.modalError) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm.done
                            ? _c(
                                "div",
                                { staticClass: "viq-actions-modal__done" },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M5 10l4 4 6-6",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.selectedCount) +
                                        " action" +
                                        _vm._s(
                                          _vm.selectedCount !== 1 ? "s" : ""
                                        ) +
                                        " sent to Workspace"
                                    ),
                                  ]),
                                ]
                              )
                            : !_vm.extracting && _vm.items.length === 0
                            ? _c(
                                "div",
                                { staticClass: "viq-actions-modal__empty" },
                                [
                                  _vm._v(
                                    "\n            No action items could be extracted from this content.\n          "
                                  ),
                                ]
                              )
                            : [
                                _c(
                                  "div",
                                  { staticClass: "viq-actions-modal__toolbar" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.selectedCount) +
                                          " of " +
                                          _vm._s(_vm.items.length) +
                                          " selected"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "viq-actions-modal__select-all",
                                        on: { click: _vm.toggleSelectAll },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.selectedCount ===
                                                _vm.items.length
                                                ? "Deselect all"
                                                : "Select all"
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "viq-actions-modal__items" },
                                  _vm._l(_vm.items, function (item, i) {
                                    return _c(
                                      "label",
                                      {
                                        key: i,
                                        staticClass: "viq-actions-modal__item",
                                        class: {
                                          "viq-actions-modal__item--selected":
                                            _vm.selected[i],
                                        },
                                      },
                                      [
                                        _c("input", {
                                          staticClass:
                                            "viq-actions-modal__checkbox",
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: _vm.selected[i],
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleItem(i)
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "viq-actions-modal__item-content",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "viq-actions-modal__item-header",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "viq-actions-modal__item-title",
                                                  },
                                                  [_vm._v(_vm._s(item.title))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "viq-actions-modal__priority",
                                                    class:
                                                      "viq-actions-modal__priority--" +
                                                      item.priority,
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.priority)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            item.description
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "viq-actions-modal__item-desc",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.description)
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "viq-actions-modal__item-meta",
                                              },
                                              [
                                                item.suggested_deadline
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "viq-actions-modal__deadline",
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              width: "10",
                                                              height: "10",
                                                              viewBox:
                                                                "0 0 10 10",
                                                              fill: "none",
                                                            },
                                                          },
                                                          [
                                                            _c("rect", {
                                                              attrs: {
                                                                x: "1",
                                                                y: "2",
                                                                width: "8",
                                                                height: "7",
                                                                rx: "1",
                                                                stroke:
                                                                  "currentColor",
                                                                "stroke-width":
                                                                  "0.8",
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M3 1v2M7 1v2M1 5h8",
                                                                stroke:
                                                                  "currentColor",
                                                                "stroke-width":
                                                                  "0.8",
                                                                "stroke-linecap":
                                                                  "round",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              item.suggested_deadline
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm._l(
                                                  (item.tags || []).slice(0, 3),
                                                  function (tag) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        key: tag,
                                                        staticClass:
                                                          "viq-actions-modal__tag",
                                                      },
                                                      [_vm._v(_vm._s(tag))]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.extracting && !_vm.done && _vm.items.length > 0
                        ? _c(
                            "div",
                            { staticClass: "viq-actions-modal__footer" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "viq-actions-modal__cancel",
                                  attrs: { disabled: _vm.saving },
                                  on: { click: _vm.closeModal },
                                },
                                [_vm._v("\n            Cancel\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "viq-actions-modal__send",
                                  attrs: {
                                    disabled:
                                      _vm.saving || _vm.selectedCount === 0,
                                  },
                                  on: { click: _vm.sendToWorkspace },
                                },
                                [
                                  _vm.saving
                                    ? _c("div", {
                                        staticClass:
                                          "viq-actions-modal__spinner viq-actions-modal__spinner--small",
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.saving
                                    ? [_vm._v("Sending...")]
                                    : [
                                        _vm._v(
                                          "\n              Send " +
                                            _vm._s(_vm.selectedCount) +
                                            " to Workspace\n              "
                                        ),
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "12",
                                              height: "12",
                                              viewBox: "0 0 12 12",
                                              fill: "none",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M6.5 2l4 4-4 4M10 6H2",
                                                stroke: "currentColor",
                                                "stroke-width": "1.2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }